import { useState } from "react";

import productFileApi from "../../api/productFileApi";
import useMount from "../../hooks/useMount";
import AlertModal from "../Commons/AlertModal";
import ActionButton from "../Commons/ActionButton";
import ProductFileModal from "./ProductFileModal";
import ListComponent from "../Commons/ListComponent";
import Pagination from "../Commons/Pagination";
import ListFilter from "../Commons/ListFilter";
import { applyListFilter, applyListSort, applyListFilterAndSort } from "../../tools/GeneralHelper";


import { getLabel, getLanguage } from "../../tools/Dictionary";


import { MdAdd, MdCheck } from "react-icons/md";


const ProductFileCont = (props) =>
{

  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const ParentLoading = props.ParentLoading;
  const setParentLoading = props.setParentLoading;
  const Selectable = props.Selectable;
  const OnSelect = props.OnSelect;


  //State
  const [loading, setLoading] = useState(true);
  const [processFile, setProductFile] = useState([]);
  const [currentProductFile, setCurrentProductFile] = useState([]);
  const [column, setColumn] = useState([
    {
      label: getLabel("T_ProductFile", "name"),
      property: "name",
      style: { width: "30%", minWidth: "50px" },
      isMobile: true,
      mobileStyle: { width: "60%", minWidth: "50px" },
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_ProductFile", "description"),
      property: "description",
      style: { width: "25%", minWidth: "50px" },
      isMobile: false,
      mobileStyle: { width: "20%", minWidth: "50px" },
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_ProductFile", "tags"),
      property: "tagString",
      style: { width: "15%", minWidth: "50px" },
      isMobile: false,
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_ProductFile", "type"),
      property: "type",
      style: { width: "15%", minWidth: "50px" },
      isMobile: false,
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_ProductFile", "format"),
      property: "format",
      style: { width: "7%", minWidth: "50px" },
      isMobile: false,
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_ProductFile", "isActive"),
      property: "isActive",
      style: { width: "8%", minWidth: "50px" },
      isMobile: false,
      mobileStyle: { width: "25%", minWidth: "50px" },
      format: "boolean",
      booleanValue: { true: getLabel("App", "Yes"), false: getLabel("App", "No") },
      filterOperator: "like",
      filterValue: ""
    },
    ...(Selectable ? 
      [
        {
          label: getLabel("App", "Action"),
          style: { width: "15%", minWidth: "50px" },
          mobileStyle: { width: "40%", minWidth: "50px" },
          isMobile: true,
          isAction: true,
          button: [
            {
              title: getLabel("App", "Select"),
              isButton: true,
              icon: <MdCheck />,
              style: { width: "60px", height: "30px", fontSize: "20px", fontWeight: "bold", backgroundColor: "#5ba644"},
              onClick: OnSelect
            }
          ],
          noFilter: true
        }
      ]: []
    )
  ]);
  const [sort, setSort] = useState({
    property: "",
    direction: 0 // Desc = 0, Asc = 1
  });
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10
  });
  const [modal, setModal] = useState({
    id: 0,
    display: false
  });
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });



  useMount(() =>
  {
    loadData();
  }, []);

  const loadData = async (_showLoading = true) =>
  {

    try
    {

      if (_showLoading)
      {
        setParentLoading(true);
        setLoading(true);
      }

      let [processFileData] = await Promise.all([
        productFileApi.getProductFiles({ select: `_id,name,description,label,tag,type,format,isActive`, translate: getLanguage().code }),
      ]);

      if (processFileData.Success)
      {

        
        // Format tags
        processFileData.Data.forEach(d => {
          d.tagString = d.tag.join("; ");
        });


        let loadedProductFile = applyListFilterAndSort(processFileData.Data, column, sort);

        setProductFile(loadedProductFile);
        checkDataUpdateForPagination(loadedProductFile, pagination);


      } else
        throw new Error(processFileData.Error.label);



      setParentLoading(false);
      setLoading(false);

    } catch (err)
    {

      setParentLoading(false);
      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

  };

  const checkDataUpdateForPagination = (_data, _pagination, _resetPage = false) =>
  {

    let tempData = _data.filter(d => !d.bFiltered);
    let maxPage = Math.ceil(tempData.length / _pagination.perPage);
    let currentPage = _pagination.page;

    if (_resetPage)
      currentPage = 1;
    else if (_pagination.page > maxPage)
    {
      currentPage = maxPage > 0 ? maxPage : 1;
    }

    setCurrentProductFile(sliceDataForPagination(_data, currentPage));

    setPagination(pagination => ({
      ...pagination,
      page: currentPage
    }));
  };

  const sliceDataForPagination = (_data, _page) =>
  {

    return _data.filter(d => !d.bFiltered).slice(pagination.perPage * (_page - 1), pagination.perPage * (_page - 1) + pagination.perPage);

  };

  const onClickSort = (_sort) =>
  {

    let tempData = applyListSort(processFile, _sort);

    setProductFile(tempData);
    checkDataUpdateForPagination(tempData, pagination);
    setSort(_sort);

  };

  const onApplyFilter = (_column) =>
  {

    let tempData = applyListFilter(processFile, _column);

    setProductFile(tempData);
    checkDataUpdateForPagination(tempData, pagination, true);
    setColumn(_column);

  };



  const onChangePage = (_page) =>
  {

    let tempPagination = {
      ...pagination,
      page: _page
    };

    checkDataUpdateForPagination(processFile, tempPagination);

  };


  const onClickItem = (_item) =>
  {

    setModal({
      id: _item._id,
      display: true
    });

  };

  const onClickNew = () =>
  {

    setModal({
      id: 0,
      display: true
    })

  };


  let currentLoading = loading || ParentLoading;

  return (
    <div className="page_body_cont">
      {modal.display &&
        <ProductFileModal
          IsDesktop={IsDesktop}
          Id={modal.id}
          Access={Access}
          OnCloseModal={() => setModal({ id: 0, display: false })}
          LoadData={() => loadData(false)}
        />
      }
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <div className="page_action_cont" style={{ width: "90%", maxWidth: "1200px" }}>
        <div className="page_action_section" style={{ width: "30%" }}>
          <ActionButton
            IsDesktop={IsDesktop}
            Label={getLabel("App", "New")}
            Icon={MdAdd}
            Disabled={currentLoading}
            OnClick={onClickNew}
          />
        </div>
        <div className="page_action_section" style={{ width: "40%", justifyContent: "center" }}>
          <Pagination
            IsDesktop={IsDesktop}
            data={pagination}
            onChangePage={onChangePage}
            count={processFile.filter(p => !p.bFiltered).length}
          />
        </div>
        <div className="page_action_section" style={{ width: "30%", justifyContent: "right" }}>
          <ListFilter
            IsDesktop={IsDesktop}
            column={column}
            Data={processFile}
            OnApplyFilter={onApplyFilter}
          />
        </div>
      </div>

      <ListComponent
        IsDesktop={IsDesktop}
        Column={column}
        Data={currentProductFile}
        Sort={sort}
        ListStyle={{ width: "90%", maxWidth: "1200px" }}
        Loading={loading}
        Debug={false}
        OnClickSort={onClickSort}
        OnClickItem={onClickItem}
        Selectable={Selectable}
        OnClickSelect={OnSelect}
      />

    </div>
  );

}


export default ProductFileCont;